import { StagedAttachment, AttachmentType } from '@api/attachments/models/Attachment.model'
import StagedAttachmentEditor from '@components/common/StagedAttachmentEditor'
import useMaintenanceAttachmentHook from './useMaintenanceAttachmentHook'

interface StagedMaintenanceAttachmentEditorProps {
  maintenanceID: string
  canEdit?: boolean
  stagedAttachments: StagedAttachment[]
  onStagedAttachmentsChange: (attachments: StagedAttachment[]) => void
  attachmentType?: AttachmentType
}

const StagedMaintenanceAttachmentEditor = ({
  maintenanceID,
  canEdit = true,
  stagedAttachments,
  onStagedAttachmentsChange,
  attachmentType = 'Asset',
}: StagedMaintenanceAttachmentEditorProps) => {
  const entityConfig = {
    entityName: 'Maintenance',
    entityIdLabel: 'Maintenance ID',
    saveMessage: 'maintenance contract',
  }

  return (
    <StagedAttachmentEditor<{ maintenanceID: string }>
      entityID={maintenanceID}
      entityConfig={entityConfig}
      canEdit={canEdit}
      stagedAttachments={stagedAttachments}
      onStagedAttachmentsChange={onStagedAttachmentsChange}
      attachmentType={attachmentType}
      useAttachmentHook={useMaintenanceAttachmentHook}
      attachmentHookParamName="maintenanceID"
      maxAttachments={1}
    />
  )
}

export default StagedMaintenanceAttachmentEditor